import { Injectable } from '@angular/core'

@Injectable({
	providedIn: 'root',
})
export class FontSizeService {
	private readonly storageKey = 'app-font-size'

	/** All possible font sizes */
	private readonly allFontSizeOptions = [
		{ key: 'xs', label: 'Extra Small' },
		{ key: 'sm', label: 'Small' },
		{ key: 'md', label: 'Default' },
		{ key: 'lg', label: 'Large' },
		{ key: 'xl', label: 'Extra Large' },
		{ key: 'two-xl', label: '2× Extra Large' },
		{ key: 'three-xl', label: '3× Extra Large' },
	]

	/** Filtered options based on screen width */
	readonly fontSizeOptions: { key: string; label: string }[]

	readonly defaultSize = 'md'

	constructor() {
		// Filter options at startup based on current screen size
		if (window.innerWidth < 425) {
			this.fontSizeOptions = this.allFontSizeOptions.filter((option) => ['xs', 'sm', 'md', 'lg', 'xl'].includes(option.key))
		} else {
			this.fontSizeOptions = [...this.allFontSizeOptions]
		}

		this.applyFontSize(this.getFontSize())
	}

	/** Returns current font size (from localStorage or default) */
	getFontSize(): string {
		const size = localStorage.getItem(this.storageKey)
		return this.optionsInclude(size!) ? size! : this.defaultSize
	}

	/** Sets font size and applies it */
	setFontSize(size: string): void {
		if (!this.optionsInclude(size)) {
			console.warn(`Invalid font size: "${size}". Falling back to default.`)
			size = this.defaultSize
		}

		localStorage.setItem(this.storageKey, size)
		this.applyFontSize(size)
	}

	/** Applies font size class to <html> element */
	private applyFontSize(size: string): void {
		const html = document.documentElement

		// Remove all font-size classes
		this.fontSizeOptions.forEach((option) => html.classList.remove(option.key))

		// Add the selected one
		html.classList.add(size)
	}

	optionsInclude(size: string) {
		return this.fontSizeOptions.some((option) => option.key === size)
	}
}
